import loadScript from '../loadScript';

const sitekeyDefault = '6LepgK4UAAAAAMrBn6phc2odLTPf-2IxS2RZMw2P';

export const grecaptchaInit = (triggerId, siteKeyClient, clb, action = null) => {
  const grecaptchaSiteKey = siteKeyClient || sitekeyDefault;

  if (!window?.grecaptcha?.render) {
    loadScript('https://www.google.com/recaptcha/api.js').then(
      () => {
        const loading = setInterval(
          () => {
            if (window.grecaptcha && 'render' in window.grecaptcha) {
              clearInterval(loading);
              window.grecaptcha.render(
                triggerId,
                {
                  ...action && { action },
                  sitekey: grecaptchaSiteKey,
                  callback: clb,
                },
              );
            }
          },
          350,
        );
      },
    );
  } else {
    window.grecaptcha.render(
      triggerId,
      {
        action,
        sitekey: grecaptchaSiteKey,
        callback: clb,
      },
    );
  }
};

export const grecaptchaExecute = () => {
  if (window.grecaptcha) {
    window.grecaptcha.execute();
  }
};
